import cep from "@/cflow/cep.js";

export default {
  idDentista: {
    ignorar: true,
    value: 0
  },
  idLaboratorio: {
    ignorar: true,
    dados: null,
    value: 0
  },
  dr: {
    label: "Dr(a).",
    value: '',
    type: 'text',
    size: 4,
    disabled: true
  },
  paciente: {
    label: "Paciente",
    type: "text",
    size: 4,
    value: 'João Carlos Almeida',
    error: null,
    required: true
  },
  idade: {
    label: "Idade",
    type: "number",
    size: 4,
    value: 32,
    error: null,
    required: true,
    max: 100,
    maxlength: 99,
    step: 1
  },
  tecnico: {
    label: "Técnico",
    type: "text",
    value: "Técnico Demonstração",
    error: null,
    leitura: false,
    ignorar: true
  },
  hr1: {
    type: "hr",
    ignorar: false
  },
  previsaoEntrega: {
    label: "Previsão de entrega",
    type: "datetime-local",
    value: '2025-11-16 11:00:00',
    error: null,
    required: true
  },
  hr3: {
    type: "hr",
    ignorar: false
  },
  h6_1: {
    type: "h6",
    label: "Preencha com atenção",
    ignorar: false
  },
  dente: {
    label: "Dente",
    type: "personalizado",
    json: true,
    value: [],
    error: null,
    opcoesDentes: [
      [18, 17, 16, 15, 14, 13, 12, 11],
      [21, 22, 23, 24, 25, 26, 27, 28],
      [48, 47, 46, 45, 44, 43, 42, 41],
      [31, 32, 33, 34, 35, 36, 37, 38],
    ],
    modelo: {
      numero: null,
      excluindo: false,
      tempoExclusao: 0,
      procedimento: {
        label: "Procedimento",
        type: "select",
        opcoes: [
          {
            valor: 1,
            nome: "Sim",
          },
          {
            valor: 0,
            nome: "Não",
          },
        ],
        size: 6,
        placeholder: "Selecione...",
        value: null,
        leitura: false,
        error: null
      },
      material: {
        label: "Material",
        type: "select",
        opcoes: [
          {
            valor: 1,
            nome: "Sim",
          },
          {
            valor: 0,
            nome: "Não",
          },
        ],
        size: 6,
        placeholder: "Selecione...",
        value: null,
        leitura: false,
        error: null,
      },
      escala: {
        label: "Escala",
        type: "select",
        opcoes: [
          {
            valor: "Vita",
            nome: "Vita",
          },
          {
            valor: "Ivoclar",
            nome: "Ivoclar",
          },
        ],
        placeholder: "Selecione...",
        size: 4,
        value: null,
        leitura: false,
        error: null,
      },
      cor: {
        label: "Cor",
        type: "select",
        opcoes: [
          {
            valor: "BL1",
            nome: "BL1",
          },
          {
            valor: "BL2",
            nome: "BL2",
          },
          {
            valor: "BL3",
            nome: "BL3",
          },
          {
            valor: "BL4",
            nome: "BL4",
          },
          {
            valor: "A1",
            nome: "A1",
          },
          {
            valor: "A2",
            nome: "A2",
          },
          {
            valor: "A3",
            nome: "A3",
          },
          {
            valor: "A4",
            nome: "A4",
          },
          {
            valor: "B1",
            nome: "B1",
          },
          {
            valor: "B2",
            nome: "B2",
          },
          {
            valor: "B3",
            nome: "B3",
          },
          {
            valor: "B4",
            nome: "B4",
          },
          {
            valor: "C1",
            nome: "C1",
          },
          {
            valor: "C2",
            nome: "C2",
          },
          {
            valor: "C3",
            nome: "C3",
          },
          {
            valor: "C4",
            nome: "C4",
          },
          {
            valor: "D1",
            nome: "D1",
          },
          {
            valor: "D2",
            nome: "D2",
          },
          {
            valor: "D3",
            nome: "D3",
          },
          {
            valor: "D4",
            nome: "D4",
          },
        ],
        placeholder: "Selecione...",
        size: 4,
        value: null,
        leitura: false,
        error: null,
      },
      brilho: {
        label: "Brilho",
        type: "select",
        opcoes: [
          {
            valor: 1,
            nome: "Alto",
          },
          {
            valor: 2,
            nome: "Médio",
          },
          {
            valor: 3,
            nome: "Baixo",
          },
        ],
        size: 4,
        placeholder: "Selecione...",
        value: null,
        leitura: false,
        error: null,
      },
      textura: {
        label: "Textura",
        type: "select",
        opcoes: [
          {
            valor: 1,
            nome: "Sim",
          },
          {
            valor: 0,
            nome: "Não",
          },
        ],
        size: 4,
        placeholder: "Selecione...",
        value: null,
        leitura: false,
        error: null,
      },
      caracterizacao_oclusal: {
        label: "Caracterização oclusal",
        type: "select",
        opcoes: [
          {
            valor: 1,
            nome: "Leve",
          },
          {
            valor: 2,
            nome: "Moderada",
          },
          {
            valor: 3,
            nome: "Acentuada",
          },
        ],
        size: 4,
        placeholder: "Selecione...",
        value: null,
        leitura: false,
        error: null,
      },
      componente: {
        label: "Componente",
        type: "select",
        opcoes: [
          {
            valor: 1,
            nome: "Pilar GM",
          },
          {
            valor: 2,
            nome: "Pilar CM",
          },
          {
            valor: 3,
            nome: "Micro-pilar",
          },
          {
            valor: 4,
            nome: "Mini-pilar 4.1",
          },
          {
            valor: 5,
            nome: "Mini-pilar 5.0",
          },
          {
            valor: 6,
            nome: "Munhão 3,3 X 4",
          },
          {
            valor: 7,
            nome: "Munhão 3,3 X 6",
          },
          {
            valor: 8,
            nome: "Munhão 4,5 X 4",
          },
          {
            valor: 9,
            nome: "Munhão 4,5 X 6",
          },
          {
            valor: 10,
            nome: "Hexagono 3,3",
          },
          {
            valor: 11,
            nome: "Hexagono 4,1",
          },
          {
            valor: 12,
            nome: "Hexagono 4,3",
          },
          {
            valor: 13,
            nome: "Hexagono 5,0",
          },
          {
            valor: 14,
            nome: "Hexagono Interno",
          }
        ],
        size: 4,
        placeholder: "Selecione...",
        value: null,
        leitura: false,
        error: null,
        disabled: true
      },
    },
    required: true
  },
  hr4: {
    type: "card",
  },
  hr5: {
    type: "hr",
  },
  h6_2: {
    type: "h6",
    label: "Acompanha este trabalho",
  },
  mais_acompanhamentos: {
    type: "checkbox",
    json: 'acompanhamento',
    opcoes: [
      {
        id: "moldeira_superior",
        nome: "Moldeira superior",
      },
      {
        id: "moldeira_inferior",
        nome: "Moldeira inferior",
      },
      {
        id: "modelo_antagonista",
        nome: "Modelo antagonista",
      },
      {
        id: "analogo",
        nome: "Análogo",
      },
      {
        id: "mordida_cera",
        nome: "Mordida em cera",
      },
      {
        id: "calcinavel",
        nome: "Calcinável",
      },
      {
        id: "articulador",
        nome: "Articulador",
      },
      {
        id: "parafuso",
        nome: "Parafuso",
      },
      {
        id: "outros",
        nome: "Outros"
      }
    ],
    value: [],
    error: null,
  },
  descricao: {
    label: "Descrição dos serviços",
    type: "textarea",
    value: null,
    error: null,
  },
  hr6: {
    type: "hr",
    ignorar: true,
  },
  h6_3: {
    type: "h6",
    label: "Complete seu cadastro informando seu endereço:",
    ignorar: true,
  },
  cep: {
    label: "CEP",
    type: "text",
    max: 10,
    mask: "#####-###",
    size: 3,
    value: null,
    error: null,
    onChange: function (r, campos, app) {
      cep.buscar(r.value.replace("-", "")).then((res) => {
        campos.estado.value = res.uf;
        campos.cidade.value = res.localidade;
        campos.bairro.value = res.bairro;
        campos.logradouro.value = res.logradouro;
        app.$refs['campo_numero'][0].$el.querySelector('input,select,textarea').focus();
      });
    },
    ignorar: true
  },
  estado: {
    label: "Estado",
    type: "text",
    max: 2,
    mask: "AA",
    size: 3,
    value: null,
    error: null,
    ignorar: true,
  },
  cidade: {
    label: "Cidade",
    type: "text",
    size: 6,
    value: null,
    error: null,
    ignorar: true,
  },
  bairro: {
    label: "Bairro",
    type: "text",
    size: 4,
    value: null,
    error: null,
    ignorar: true,
  },
  logradouro: {
    label: "Endereço",
    type: "text",
    size: 6,
    value: null,
    error: null,
    ignorar: true,
  },
  numero: {
    label: "Nº",
    type: "text",
    mask: "#######",
    size: 2,
    value: null,
    error: null,
    ignorar: true,
  },
  complemento: {
    label: "Complemento",
    type: "text",
    value: null,
    error: null,
    ignorar: true,
  },
}